(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('video').forEach(function (v) {
      v.setAttribute('controlslist', 'nodownload');
      v.setAttribute('disablepictureinpicture', '');
      v.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    });
  });

  // Auch für deferred (lazy) Videos nachrüsten
  document.addEventListener('play', function (e) {
    if (e.target.tagName === 'VIDEO') {
      e.target.setAttribute('controlslist', 'nodownload');
      e.target.setAttribute('disablepictureinpicture', '');
    }
  }, true);
  } catch(e) { console.error(e); }
})();

})();
